import {
	GET_CLICKED_USER_FAIL,
	GET_CLICKED_USER_SUCCESS,
	GET_PROJECTS_FAIL,
	GET_PROJECTS_SUCCESS,
	GET_ROLES_FAIL,
	GET_ROLES_SUCCESS,
	GET_USERS_FAIL,
	GET_USERS_SUCCESS,
	GET_USER_BY_ID_FAIL,
	GET_USER_BY_ID_SUCCESS,
	GET_ALL_ACCESSIBILITIES_FAIL,
	GET_ALL_ACCESSIBILITIES_SUCCESS,
	GET_PROJECT_LIST_BY_ID_SUCCESS,
	GET_PROJECT_LIST_BY_ID_FAIL,
	GET_ROLES_ACCESSIBILITIES_SUCCESS,
	GET_ROLES_ACCESSIBILITIES_FAIL,
	GET_ACCESSIBILITIES_BY_ROLE_SUCCESS,
	GET_ACCESSIBILITIES_BY_ROLE_FAIL,
	GET_ARCHIVED_USERS_SUCCESS,
	GET_ARCHIVED_USERS_FAIL,
	GET_ROLES_ALL_PROJECTS_SUCCESS,
	GET_ROLES_ALL_PROJECTS_FAIL,
	SET_PROJECT_SELECTED_CODE,
	CLEAR_USER_BY_ID,
} from './types';

const initialState = {
	users: [],
	archivedUsers: [],
	projects: [],
	userClicked: '',
	roles: [],
	rolesOfAllProjects: [],
	rolesAccessibilities: {},
	userById: {},
	accessibilities: [],
	projectList: [],
	accessibilitiesByRole: {},
	projectSelectedCode: '',
	loading: true,
};

export default function (state = initialState, action) {
	const { type, payload } = action;
	switch (type) {
		case GET_USERS_SUCCESS:
		case GET_USERS_FAIL:
			return {
				...state,
				loading: false,
				users: payload,
			};
		case GET_PROJECTS_SUCCESS:
		case GET_PROJECTS_FAIL:
			return {
				...state,
				loading: false,
				projects: payload,
			};
		case GET_CLICKED_USER_SUCCESS:
		case GET_CLICKED_USER_FAIL:
			return {
				...state,
				loading: false,
				userClicked: payload,
			};
		case GET_ROLES_SUCCESS:
		case GET_ROLES_FAIL:
			return {
				...state,
				loading: false,
				roles: payload,
			};
		case GET_USER_BY_ID_SUCCESS:
		case GET_USER_BY_ID_FAIL:
			return {
				...state,
				loading: false,
				userById: payload,
			};
		case GET_ALL_ACCESSIBILITIES_SUCCESS:
		case GET_ALL_ACCESSIBILITIES_FAIL:
			return {
				...state,
				loading: false,
				accessibilities: payload,
			};
		case GET_PROJECT_LIST_BY_ID_SUCCESS:
		case GET_PROJECT_LIST_BY_ID_FAIL:
			return {
				...state,
				loading: false,
				projectList: payload,
			};

		case GET_ROLES_ACCESSIBILITIES_SUCCESS:
			return {
				...state,
				loading: false,
				rolesAccessibilities: payload,
			};
		case GET_ROLES_ACCESSIBILITIES_FAIL:
			return {
				...state,
				loading: false,
				rolesAccessibilities: {},
			};

		case GET_ACCESSIBILITIES_BY_ROLE_SUCCESS:
		case GET_ACCESSIBILITIES_BY_ROLE_FAIL:
			return {
				...state,
				loading: false,
				accessibilitiesByRole: payload,
			};
		case GET_ARCHIVED_USERS_SUCCESS:
			return {
				...state,
				loading: false,
				archivedUsers: payload,
			};
		case GET_ARCHIVED_USERS_FAIL:
			return {
				...state,
				loading: false,
				archivedUsers: [],
			};
		case GET_ROLES_ALL_PROJECTS_SUCCESS:
			return {
				...state,
				loading: false,
				rolesOfAllProjects: payload,
			};
		case GET_ROLES_ALL_PROJECTS_FAIL:
			return {
				...state,
				loading: false,
				rolesOfAllProjects: [],
			};
		case SET_PROJECT_SELECTED_CODE:
			return {
				...state,
				projectSelectedCode: payload,
			};
		case CLEAR_USER_BY_ID:
			return {
				...state,
				userById: {},
			};
		default:
			return state;
	}
}
